import React, { ButtonHTMLAttributes } from "react";
import styles from "./style.module.scss";

export const TransparentText: React.FC<ButtonHTMLAttributes<HTMLButtonElement> > = ({children}) => {
  return <span className={styles.Text}>{" " + children + " "}</span>;
};
